import React from 'react'

import { Spinner } from 'components'

export const getSpinner = () => (
  <Spinner />
)
